import React, { useRef } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { i18n } from 'config/locales';
import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import { IDENTIFICATION } from 'constants/sections';
import { formTypes } from 'config/formTypes';
import Intro from 'components/Section/Identification/Intro';
import ApplicantName from 'components/Section/Identification/ApplicantName';
import ApplicantBirthDate from 'components/Section/Identification/ApplicantBirthDate';
import ApplicantBirthPlace from 'components/Section/Identification/ApplicantBirthPlace';
import ApplicantSSN from 'components/Section/Identification/ApplicantSSN';
import OtherNames from 'components/Section/Identification/OtherNames';
import ContactInformation from 'components/Section/Identification/ContactInformation';
import Physical from 'components/Section/Identification/Physical';
import Review from 'components/Section/Identification/Review';
import { rootSelectors } from '@redux/modules/selectors';
import { RootState } from 'types/state';
import SectionNotFound from '../shared/SectionNotFound';

const Identification: React.FC<RouteComponentProps> = ({ location }) => {
  const subsection = useSelector((state: RootState) => state.section.subsection);
  const isReview = useSelector(rootSelectors.section.getIsSectionInReview);
  const formType = useSelector(rootSelectors.application.getFormType);
  const backRef = useRef<HTMLAnchorElement>(null);

  const subsectionLibrary = {
    intro: Intro,
    name: ApplicantName,
    birthdate: ApplicantBirthDate,
    birthplace: ApplicantBirthPlace,
    ssn: ApplicantSSN,
    othernames: OtherNames,
    contacts: ContactInformation,
    physical: Physical,
    review: Review,
  };

  const form = formTypes[formType];
  const section = form.find((s) => s.key === IDENTIFICATION);
  const subsectionClasses = `view view-${subsection.name || 'unknown'}`;
  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div className="section-view">
      {title && <h1 className="title">{title}</h1>}
      {para}

      <div className={subsectionClasses}>
        {isReview && (
          <div className="top-btns">
            <ErrorList />
          </div>
        )}

        <Switch>
          {section.subsections.map((sub) => (
            <Route
              key={sub.key}
              path={`/form/${section.path}/${sub.path}`}
              render={(props) => {
                const Component = subsectionLibrary[sub.name];
                return <Component {...props} backRef={backRef} />;
              }}
            />
          ))}
          <Route component={SectionNotFound} />
        </Switch>

        <SectionNavigation backRef={backRef} currentPath={location.pathname} />
      </div>
    </div>
  );
};

Identification.defaultProps = {
  location: {},
};

export default Identification;

export const IdentificationSections = () => <Review />;
